document.addEventListener("click", function (event) {
  const openBtn = event.target.closest(".velora-menu-btn");
  const closeBtn = event.target.closest(".velora-drawer-close");
  const drawerOverlay = event.target.closest(".velora-drawer-overlay");

  if (openBtn) {
    document.body.classList.add("velora-menu-open");
  }

  if (closeBtn || drawerOverlay) {
    document.body.classList.remove("velora-menu-open");
  }
});

window.addEventListener("scroll", function () {
  const header = document.querySelector("[data-velora-header]");
  if (header) {
    header.classList.toggle("is-scrolled", window.scrollY > 20);
  }

  const miniHeader = document.querySelector("[data-mini-header]");
  if (miniHeader) {
   miniHeader.classList.toggle("is-visible", window.scrollY > 420);
  }
});

document.addEventListener("mousemove", function (event) {
  const cardImage = event.target.closest(".velora-product-card__image");
  if (!cardImage) return;

  const rect = cardImage.getBoundingClientRect();
  cardImage.style.setProperty("--x", event.clientX - rect.left + "px");
  cardImage.style.setProperty("--y", event.clientY - rect.top + "px");
});

document.addEventListener("click", function (event) {
  const openScent = event.target.closest("[data-scent-open]");
  const closeScent = event.target.closest("[data-scent-close]");
  const scentOverlay = event.target.closest("[data-scent-overlay]");

  if (openScent) {
    document.body.classList.add("velora-scent-open");
  }

  if (closeScent || scentOverlay) {
    document.body.classList.remove("velora-scent-open");
  }
});

document.addEventListener("click", function (event) {
  const choice = event.target.closest("[data-scent-choice]");
  if (!choice) return;

  const result = document.querySelector("[data-scent-result-links]");
  if (!result) return;

  document.querySelectorAll("[data-scent-choice]").forEach(function (btn) {
    btn.classList.remove("is-active");
  });

  choice.classList.add("is-active");

  const scents = {
    sweet: [
      ["Angel Dust", "angel-dust"],
      ["Love Spell", "love-spell"],
      ["Pink Sugar Cashmere", "pink-sugar-cashmere"]
    ],
    fresh: [
      ["Volcanic Expression", "volcanic-expression"],
      ["Blue Agave Melon", "blue-agave-melon"],
      ["Magic Dust", "magic-dust"]
    ],
    floral: [
      ["Orange Blossom Marshmallow", "orange-blossom-marshmallow"],
      ["Majestic Bloom", "majestic-bloom"],
      ["Iris Spell", "iris-spell"]
    ],
    tropical: [
      ["Brazilian Bum Bliss", "brazilian-bum-bliss"],
      ["Coconut Guava Breeze", "coconut-guava-breeze"],
      ["Glazed", "glazed"]
    ],
    bold: [
      ["My Man", "my-man"],
      ["L.A. Nights", "l-a-nights"],
      ["Bourbon Butterscotch", "bourbon-butterscotch"]
    ]
  };

  const selectedMood = choice.getAttribute("data-scent-choice");
  const recommendations = scents[selectedMood] || scents.sweet;
  result.replaceChildren();

  recommendations.forEach(function (recommendation) {
    const link = document.createElement("a");
    link.href = "/pages/fragrance#" + recommendation[1];
    link.textContent = recommendation[0];
    link.setAttribute("data-scent-jump", "");
    result.appendChild(link);
  });
});

document.addEventListener("click", function (event) {
  const scentJump = event.target.closest("[data-scent-jump]");
  if (!scentJump) return;
  document.body.classList.remove("velora-scent-open");
});

document.addEventListener("mousemove", function (event) {
  const galaxy = document.querySelector("[data-scent-galaxy]");
  const orb = document.querySelector("[data-galaxy-orb]");

  if (!galaxy || !orb || window.innerWidth < 990) return;

  const rect = galaxy.getBoundingClientRect();
  const x = (event.clientX - rect.left) / rect.width - 0.5;
  const y = (event.clientY - rect.top) / rect.height - 0.5;

  orb.style.transform = `translate(-50%, -50%) rotateX(${12 + y * -18}deg) rotateY(${-14 + x * 22}deg)`;
});

document.addEventListener("mouseover", function (event) {
  const card = event.target.closest("[data-scent-card]");
  const preview = document.querySelector("[data-scent-preview]");

  if (!card || !preview) return;

  const title = card.getAttribute("data-title");
  const note = card.getAttribute("data-note");
  const products = card.getAttribute("data-products");

  preview.querySelector("h3").textContent = title;
  preview.querySelector("span").textContent = note;
  preview.querySelector("small").textContent = products;
});

document.addEventListener("mouseover", function (event) {
  const card = event.target.closest("[data-scent-card]");
  const preview = document.querySelector("[data-scent-preview]");

  if (!card || !preview) return;

  const title = card.getAttribute("data-title");
  const note = card.getAttribute("data-note");
  const products = card.getAttribute("data-products");
  const link = card.getAttribute("data-link");

  preview.querySelector("h3").textContent = title;
  preview.querySelector("span").textContent = note;
  preview.querySelector("small").textContent = products;

  const previewLink = document.querySelector("[data-scent-preview-link]");
  if (previewLink && link) {
    previewLink.setAttribute("href", link);
  }
});
document.addEventListener("mousemove", function (event) {
  const cards = document.querySelectorAll("[data-world-card]");

  cards.forEach(function (card) {
    const rect = card.getBoundingClientRect();

    if (
      event.clientX < rect.left ||
      event.clientX > rect.right ||
      event.clientY < rect.top ||
      event.clientY > rect.bottom
    ) {
      card.style.transform = "";
      return;
    }

    if (window.innerWidth < 990) return;

    const x = (event.clientX - rect.left) / rect.width - 0.5;
    const y = (event.clientY - rect.top) / rect.height - 0.5;

    card.style.transform = `translateY(-14px) rotateX(${y * -7}deg) rotateY(${x * 7}deg)`;
  });
});
/* =========================================================
   JERRBEAR MOBILE-ONLY INTERACTIONS
   Desktop (750px+) is intentionally untouched.
========================================================= */
(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let cleanup = null;

  function injectMobileStyles() {
    if (document.getElementById('jerrbear-mobile-effects-css')) return;

    const style = document.createElement('style');
    style.id = 'jerrbear-mobile-effects-css';
    style.textContent = `
      @media screen and (max-width: 749px) {
        body.jb-mobile-effects-ready .jb-mobile-reveal {
          opacity: 0 !important;
          transform: translate3d(0, 30px, 0) scale(.985) !important;
          filter: blur(7px) !important;
          transition: opacity .72s cubic-bezier(.16,1,.3,1), transform .82s cubic-bezier(.16,1,.3,1), filter .82s ease !important;
          will-change: opacity, transform, filter !important;
        }

        body.jb-mobile-effects-ready .jb-mobile-reveal.jb-mobile-inview {
          opacity: 1 !important;
          transform: translate3d(0, 0, 0) scale(1) !important;
          filter: blur(0) !important;
        }

        body.jb-mobile-effects-ready .velora-product-card,
        body.jb-mobile-effects-ready .jb-icon-benefits__card,
        body.jb-mobile-effects-ready .jb-orbit-img-card__inner {
          transition: transform .38s cubic-bezier(.16,1,.3,1), box-shadow .38s ease, opacity .38s ease !important;
        }

        body.jb-mobile-effects-ready .velora-product-card.jb-mobile-active,
        body.jb-mobile-effects-ready .jb-icon-benefits__card.jb-mobile-active,
        body.jb-mobile-effects-ready .jb-orbit-img-card__inner.jb-mobile-active {
          transform: translate3d(0,-5px,0) scale(1.015) !important;
          box-shadow: 0 20px 42px rgba(92,114,109,.16) !important;
        }

        body.jb-mobile-effects-ready .velora-product-card.jb-mobile-active .velora-product-card__image img,
        body.jb-mobile-effects-ready .jb-orbit-img-card__inner.jb-mobile-active .jb-orbit-img-card__photo img {
          transform: scale(1.055) !important;
        }

        body.jb-mobile-effects-ready .velora-product-card__image img,
        body.jb-mobile-effects-ready .jb-orbit-img-card__photo img {
          transition: transform .75s cubic-bezier(.16,1,.3,1) !important;
        }

        body.jb-mobile-effects-ready .velora-products__grid,
        body.jb-mobile-effects-ready .jb-icon-benefits__grid {
          scroll-behavior: smooth !important;
          scroll-padding-inline: 18px !important;
        }

        body.jb-mobile-effects-ready .velora-menu-btn:active,
        body.jb-mobile-effects-ready .velora-action-cart:active,
        body.jb-mobile-effects-ready a[class*="btn"]:active,
        body.jb-mobile-effects-ready button:active {
          transform: scale(.96) !important;
        }

        body.velora-menu-open .velora-drawer__links > a,
        body.velora-menu-open .velora-drawer-dropdown {
          opacity: 1 !important;
          transform: translateX(0) !important;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function initMobileEffects() {
    if (!mobileQuery.matches || cleanup) return;

    injectMobileStyles();
    document.body.classList.add('jb-mobile-effects-ready');

    const header = document.querySelector('[data-velora-header]');
    const menuButtons = Array.from(document.querySelectorAll('.velora-menu-btn'));
    const closeButton = document.querySelector('.velora-drawer-close');
    const overlay = document.querySelector('.velora-drawer-overlay');

    const updateHeader = () => {
      if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
    };

    const updateExpanded = () => {
      const open = document.body.classList.contains('velora-menu-open');
      menuButtons.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    };

    const queueExpandedUpdate = () => window.requestAnimationFrame(updateExpanded);
    menuButtons.forEach((button) => button.addEventListener('click', queueExpandedUpdate));
    if (closeButton) closeButton.addEventListener('click', queueExpandedUpdate);
    if (overlay) overlay.addEventListener('click', queueExpandedUpdate);

    const onEscape = (event) => {
      if (event.key !== 'Escape') return;
      document.body.classList.remove('velora-menu-open');
      updateExpanded();
    };

    const revealSelectors = [
      '.velora-products__top',
      '.velora-product-card',
      '.jb-scent-memory-3d__top',
      '.jb-orbit-img-card',
      '.jb-scent-featured-card',
      '.rich-text__wrapper',
      '.banner',
      '.jb-icon-benefits__header',
      '.jb-icon-benefits__card'
    ].join(',');

    const revealItems = Array.from(document.querySelectorAll(revealSelectors));
    revealItems.forEach((item, index) => {
      item.classList.add('jb-mobile-reveal');
      item.style.transitionDelay = `${Math.min(index % 4, 3) * 70}ms`;
    });

    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('jb-mobile-inview');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -5% 0px' });

    revealItems.forEach((item) => revealObserver.observe(item));

    const interactiveItems = Array.from(document.querySelectorAll(
      '.velora-product-card, .jb-icon-benefits__card, .jb-orbit-img-card__inner'
    ));

    const setActive = (item) => {
      interactiveItems.forEach((candidate) => candidate.classList.toggle('jb-mobile-active', candidate === item));
    };

    const activeObserver = new IntersectionObserver((entries) => {
      const centered = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => {
          const viewportCenter = window.innerHeight / 2;
          const aCenter = a.boundingClientRect.top + a.boundingClientRect.height / 2;
          const bCenter = b.boundingClientRect.top + b.boundingClientRect.height / 2;
          return Math.abs(aCenter - viewportCenter) - Math.abs(bCenter - viewportCenter);
        })[0];

      if (centered) setActive(centered.target);
    }, { threshold: [0.45, 0.65, 0.85] });

    interactiveItems.forEach((item) => {
      activeObserver.observe(item);
      item.addEventListener('touchstart', () => setActive(item), { passive: true });
    });

    window.addEventListener('scroll', updateHeader, { passive: true });
    document.addEventListener('keydown', onEscape);
    updateHeader();
    updateExpanded();

    cleanup = () => {
      window.removeEventListener('scroll', updateHeader);
      document.removeEventListener('keydown', onEscape);
      revealObserver.disconnect();
      activeObserver.disconnect();
      menuButtons.forEach((button) => button.removeEventListener('click', queueExpandedUpdate));
      if (closeButton) closeButton.removeEventListener('click', queueExpandedUpdate);
      if (overlay) overlay.removeEventListener('click', queueExpandedUpdate);
      document.body.classList.remove('jb-mobile-effects-ready');
      interactiveItems.forEach((item) => item.classList.remove('jb-mobile-active'));
      cleanup = null;
    };
  }

  function syncMode() {
    if (mobileQuery.matches) initMobileEffects();
    else if (cleanup) cleanup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMode, { once: true });
  } else {
    syncMode();
  }

  if (typeof mobileQuery.addEventListener === 'function') {
    mobileQuery.addEventListener('change', syncMode);
  } else if (typeof mobileQuery.addListener === 'function') {
    mobileQuery.addListener(syncMode);
  }
})();
